var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import { Prop } from 'vue-property-decorator';
import { getTimeAgo, formatPlayerTime } from '../../../common/format';
import { toDtPosterParams, DtModuleId, DtEid } from '../../../common/reporter';
let VideoItem = class VideoItem extends VueType {
    get timeAgo() {
        return getTimeAgo(Number(this.data.video_uploadTime));
    }
    get duration() {
        return formatPlayerTime(this.data.duration);
    }
    get isShow() {
        const { firstIndex, lastIndex } = this.renderIndexs;
        return this.index >= firstIndex && this.index <= lastIndex;
    }
    get url() {
        return `//v.qq.com/x/page/${this.data.vid}.html`;
    }
    get dtPosterParams() {
        return toDtPosterParams({
            mod_id: DtModuleId.SUBSCRIBE,
            mod_idx: 3,
            tab_title: '',
            item_idx: this.index,
            is_hover: 0,
            vid: this.data.vid,
        });
    }
    render() {
        const { data } = this;
        return <div class="sub_video item_size" v-show={this.isShow} v-wind dt-eid={DtEid.POSTER} dt-params={this.dtPosterParams}>
            <a href={this.url} target="_blank" class="sub_video_pic_box del_par" dt-source-el={this.dtPosterParams}>
                <img v-src={data.pic}></img>
                <span>{this.duration}</span>
                <div class="hover_mask">
                    <div class="hover_mask_play"></div>
                </div>
            </a>
            <strong class="sub_video_tit_box nowrap_two">
                <a href={this.url} target="_blank" class="sub_video_title nowrap_two" dt-source-el={this.dtPosterParams}>{data.title}</a>
            </strong>
            <span class="sub_video_update">{this.timeAgo}</span>
        </div>;
    }
};
__decorate([
    Prop()
], VideoItem.prototype, "data", void 0);
__decorate([
    Prop()
], VideoItem.prototype, "index", void 0);
__decorate([
    Prop()
], VideoItem.prototype, "renderIndexs", void 0);
VideoItem = __decorate([
    Component
], VideoItem);
export default VideoItem;
